import { render } from "./CategoriesList.vue?vue&type=template&id=e7d38caa"
import script from "./CategoriesList.vue?vue&type=script&lang=js"
export * from "./CategoriesList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__